// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"1ebdf88d438e9ee828f3","655":"17e0ab60ecc2ae20a4d3"}[chunkId] + ".js";
};